/**
 * AuthoritiesDocument — registry entry for the `power_of_attorney` flow.
 *
 * The flow id is the BE's single document configuration type; this component is
 * the configurator behind it and hosts both of its pages.
 */

import type { PfConfigModule } from '../registry'
import { AuthoritiesDocument } from './AuthoritiesDocument.component'

export const authoritiesDocumentModule: PfConfigModule = {
  flowId: 'power_of_attorney',
  Component: AuthoritiesDocument,
}
